import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';
import './utils/axiosInterceptor';
import { initSentry } from './utils/sentry';
import { initializeAuthStorage, migrateFromUnencryptedStorage } from './utils/secureAuthStorage';
import { registerServiceWorker } from './utils/registerServiceWorker';

// Build-time stamp for verifying which bundle is loaded.
console.info(
  `🚀 DomainBoost Web App built at ${typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : 'unknown'}`
);

// Initialize Sentry for error tracking
initSentry();

// Initialize secure auth storage (load encrypted data into cache) and
// migrate any unencrypted data BEFORE mounting React. Mounting before init
// would mean the first render of TopBar / route loaders sees cache.initialized
// === false → null credentials → empty session timer / unauthenticated state.
async function bootstrap(): Promise<void> {
  try {
    await migrateFromUnencryptedStorage();
    await initializeAuthStorage();
  } catch (err) {
    console.error('Auth storage init failed:', err);
  }

  // PWA service worker registration — shared shape across PE / admin / webapp.
  // See ./utils/registerServiceWorker for the runtime + update toast wiring.
  registerServiceWorker();

  createRoot(document.getElementById('root')!).render(<App />);
}

void bootstrap();
